<template>
  <b-modal
    id="upload-brand-logo-modal"
    title="Upload Brand Logo"
    no-close-on-backdrop
  >
    <div id="image-brand-logo-container" class="border mx-auto">
      <croppa
        v-model="cropper"
        @new-image-drawn="onNewImageDrawn"
        @zoom="onZoom"
        :width="335"
        :height="140"
        placeholder="Choose a Image"
        :show-remove-button="true"
        :placeholder-font-size="14"
        remove-button-color="#ff8828"
        accept="image/*"
      >
      </croppa>
    </div>
    <div class="mx-auto mt-2">
      <input
        type="range"
        @input="onSliderChange"
        :min="sliderMin"
        :max="sliderMax"
        :step="sliderStep"
        v-model="sliderVal"
        class="custom-range"
      />
    </div>
    <div slot="modal-footer">
      <b-button
        variant="secondary"
        @click="$root.$emit('bv::hide::modal', 'upload-brand-logo-modal')"
        class="mr-1"
      >
        Cancel
      </b-button>
      <b-button variant="primary" @click="onSave" class="ml-1"> Save </b-button>
    </div>
  </b-modal>
</template>

<script>
import { mapState, mapMutations } from "vuex";
export default {
  name: "UploadWebLogoModal",
  data() {
    return {
      cropper: {},
      sliderVal: 0,
      sliderMin: 0,
      sliderMax: 0,
      sliderStep: ".001",
      base64Image: null,
    };
  },
  computed: {
    ...mapState("designs", ["webLogo"]),
  },
  methods: {
    ...mapMutations("designs", ["setWebLogo"]),
    onNewImageDrawn() {
      this.sliderVal = this.cropper.scaleRatio;
      this.sliderMin = this.cropper.scaleRatio / 2;
      this.sliderMax = this.cropper.scaleRatio * 2;
    },
    onZoom() {
      this.sliderVal = this.cropper.scaleRatio;
    },
    onSliderChange(evt) {
      let increment = evt.target.value;
      this.cropper.scaleRatio = +increment;
    },
    onSave() {
      this.$emit("setBrandLogoImage", this.cropper.generateDataUrl());
      this.$root.$emit("bv::hide::modal", "upload-brand-logo-modal");

      this.$nextTick(() => {
        this.cropper.remove(); // reset croppa value after setting brand_image to parent component
      });
    },
  },
};
</script>

<style lang="scss">
#upload-brand-logo-modal {
  #image-brand-logo-container {
    width: 335px;
    height: 140px;
  }
  .croppa-container {
    position: relative;
    text-align: center;
    .icon-remove {
      position: absolute;
      top: -10px !important;
      right: -10px !important;
      background: white;
      border-radius: 50%;
      cursor: pointer;
    }
  }
}
</style>